import { render, staticRenderFns } from "./SettingsEmailAlertView.vue?vue&type=template&id=f5ad6402&scoped=true&"
import script from "./SettingsEmailAlertView.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailAlertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ad6402",
  null
  
)

export default component.exports